import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { TranslateService } from "@ngx-translate/core";
// import { Http } from '@angular/http';
import { ServiceProvider } from "./../../providers/service/service";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Storage } from "@ionic/storage";
// import { Http, RequestOptions, Headers } from "@angular/http";

@IonicPage()
@Component({
  selector: "page-shopper-social-group-create-shop-new",
  templateUrl: "shopper-social-group-create-shop-new.html",
})
export class ShopperSocialGroupCreateShopNewPage {
  private data: FormGroup;
  plaza_id = "";
  public qrData = null;
  public createdCode: string = null;
  theme = 1;
  code: string = "";

  constructor(
    private services: ServiceProvider,
    private formBuilder: FormBuilder,
    // private http: Http,
    private storage: Storage,
    public navCtrl: NavController,
    private translateService: TranslateService,
    public navParams: NavParams
  ) {
    this.plaza_id = this.navParams.data.plaza_id;

    this.data = this.formBuilder.group({
      group_name: ["", Validators.compose([Validators.required])],
      no_member: ["", Validators.compose([Validators.required])],
    });
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    // console.log('ionViewDidLoad ShopperSocialGroupCreateShopNewPage');
  }

  /** getCode for new function */
  getCode() {
    // this.storage.get("token").then((token) => {
    // var link = this.services.URLPlazaRentSpaceCode;
    // var headers = new Headers();
    // headers.append("Accept", "application/json");
    // headers.append("Authorization", "Bearer " + token);
    // const requestOptions = new RequestOptions({ headers: headers });
    // this.http
    //   .post(
    //     link,
    //     {
    //       space_id: this.space,
    //       shop_id: this.shopVal,
    //       discount: this.discountVal,
    //     },
    //     requestOptions
    //   )
    //   .map((res) => res.json())
    //   .subscribe(
    //     (data) => {
    //       console.log(data);
    //       this.code = data;
    //     },
    //     (error) => {
    //       var response = JSON.parse(error._body);
    //       this.translateService.get(response.message).subscribe((value) => {
    //         this.services.presentToast(value);
    //       });
    //     }
    //   );
    // });
  }

  confirm() {
    let dataVal = this.data.value;

    if (!dataVal.group_name || !dataVal.no_member) {
      this.translateService.get("error blank").subscribe((value) => {
        this.services.presentToast(value);
      });
      return false;
    } else {
      this.qrData = {
        group_name: dataVal.group_name,
        no_member: dataVal.no_member,
      };

      this.createdCode = JSON.stringify(this.qrData);
    }
  }

  copyToClipboard = (): boolean => {
    const el = document.createElement("textarea");
    el.value = this.code;
    el.setAttribute("readonly", "");
    // el.style = { position: "absolute", left: "-9999px" };
    document.body.appendChild(el);

    el.select();
    // Copy text to clipboard
    try {
      const successful = document.execCommand("copy");
      if (successful) {
        document.body.removeChild(el);
        // copy to clipboard
        this.services.presentToast("copied!");
        return true;
      }
    } catch (err) {
      return false;
    }

    return false;
  };

  backPage() {
    this.navCtrl.pop();
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-social-group-create-shop-new/shopper-social-group-create-shop-new.ts